(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/share-socials.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/share-socials.js');

'use strict';

const ReactIcon = svs.ui.ReactIcon;
const links = svs.grassroots.links;
const baseUrl = svs.core.data.baseUrl;
const copyDialog = () => new svs.ui.dialog.Confirm({
  branding: svs.ui.dialog.branding.TUR,
  type: svs.ui.dialog.type.INFO,
  icon: 'thumbs-up',
  title: 'Länken kopierad',
  message: [{
    type: svs.ui.dialog.message.TEXT,
    text: 'Klistra in den i ett SMS, e-post, chatt eller valfritt meddelande.'
  }],
  actions: [{
    title: 'OK'
  }]
});
const ShareSocials = _ref => {
  let id = _ref.id,
    longname = _ref.longname,
    shortname = _ref.shortname;
  const handleCopyLink = event => {
    var _navigator;
    event.preventDefault();
    (_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.clipboard) === null || _navigator === void 0 || _navigator.writeText("".concat(window.location.origin).concat(baseUrl).concat(links.single(id, shortname)));
    svs.ui.dialog.api.add(copyDialog());
  };
  return React.createElement("div", {
    className: "margin-top-2 margin-bottom-1"
  }, React.createElement("p", null, React.createElement("a", {
    className: "fc-navy ",
    href: "#",
    onClick: handleCopyLink
  }, "Kopiera"), ' ', "eller dela f\xF6r att hj\xE4lpa f\xF6reningen f\xE5 fler supportrar."), React.createElement("div", {
    className: "grassroots-receiver-details-share-links"
  }, React.createElement("a", {
    href: "mailto:?subject=Jag st\xF6djer ".concat(longname, ". G\xF6r det du ocks\xE5!&body=Genom Gr\xE4sroten f\xF6rdelar Svenska Spel-koncernen miljoner kronor till ungdomsidrotten och f\xF6reningslivet. Sj\xE4lvklart \xE4r det gratis. Du kan hj\xE4lpa till s\xE5 att ").concat(longname, " f\xE5r en del av potten genom att klicka p\xE5 l\xE4nken: ").concat(window.location.href),
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, React.createElement(ReactIcon, {
    className: "u-text-decoration-none",
    icon: "mail-outline",
    size: "300"
  })), React.createElement("a", {
    href: "https://www.facebook.com/sharer/sharer.php?u=".concat(window.location.href),
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, React.createElement(ReactIcon, {
    className: "u-text-decoration-none",
    icon: "facebook",
    size: "300"
  })), React.createElement("a", {
    href: "https://x.com/intent/tweet?url=".concat(window.location.href),
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, React.createElement(ReactIcon, {
    className: "u-text-decoration-none",
    icon: "twitter",
    size: "300"
  }))));
};
svs.grassroots.components.receiver.share_socials = ShareSocials;

 })(window);